import { render, staticRenderFns } from "./StartMetrics.vue?vue&type=template&id=62fdc547"
import script from "./StartMetrics.vue?vue&type=script&lang=js"
export * from "./StartMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports